import { GenericDateFilterFactory } from "../../Common/_generics/GenericDateFilterFactory";

export const PMSLocationLogsDateFilter = GenericDateFilterFactory("PMS_LOCATION_LOGS");